import AppoinmentPasien from "../../components/AppoinmentPasien/AppoinmentPasien";

export default function Appoinment() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AppoinmentPasien/>
    </div>
  );
}
